export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';

export const showNotification = ( message ) => ({
    type: SHOW_NOTIFICATION,
    payload: { message },
});
